import {VehicleModel} from './vehicle-model';
import {Park} from './park';
import {VehicleType} from './vehicle-type';

export class Vehicle {
	public id: number;
	public plate: string;
	// public is_available: boolean;
	public model: VehicleModel;
	public type: VehicleType;
	public park: Park;
	public prefix: string;
	//? i 4 campi successivi sono aggiunti solo per essere usati nella tabella dei veicoli in superadmin tools
	public modelName: string;
	public modelBrandName: string;
	public typeSupertypeName: string;
	public typeName: string;

	constructor(server_obj) {
		this.prefix = 'vhc_';
		if (server_obj) {
			this.id = Number(server_obj[this.prefix + 'id']);
			this.plate = server_obj[this.prefix + 'plate'];
			// this.is_available = server_obj[this.prefix + 'is_available'];

			this.model = new VehicleModel(server_obj);
			this.type = new VehicleType(server_obj);
			this.park = new Park(server_obj);
		} else {
			this.model = new VehicleModel(undefined);
			this.type = new VehicleType(undefined);
			this.park = new Park( undefined);
		}
	}
}
